import { SB } from '@play-co/replicant';

export const match2DailyChallengeSchema = {
  day: SB.int(),
  startingLevel: SB.int(),
  timestamp: SB.int(),
  progress: SB.int(),
  autoPopupShown: SB.boolean().default(false),
  rewardsClaimed: SB.boolean().default(false),
};
